import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpSentEvent, HttpHeaderResponse, HttpProgressEvent, HttpResponse, HttpUserEvent, HttpErrorResponse } from "@angular/common/http";
import {Observable, BehaviorSubject } from 'rxjs';
import { ACCESS_TOKEN, EXCLUDED_URLS } from '../utils/common.constants';
import { catchError, map, finalize } from "rxjs/operators";
import * as CommonConstants from 'src/app/utils/common.constants';
import { throwError } from 'rxjs';
import { filter,switchMap,take} from 'rxjs/operators';
import { HTTPStatus} from '../security/app.HttpListener';
import { Router } from '@angular/router';
import { AuthService } from '../security/auth.service';
import { SharedService } from '../utils/shared.service';
declare var swal: any;

@Injectable()
export class InterceptedHttp implements HttpInterceptor {
    isRefreshingToken: boolean = true;
    tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    priviliges: any[];

    constructor(private status: HTTPStatus,private inj: Injector, private router: Router) {}
    /*
     * Http Interceptor
     */
    /* intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any | HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
        return next.handle(this.addToken(request));
    } */

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any | HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
        const auth = this.inj.get(AuthService);
        const _sharedService = this.inj.get(SharedService);


        if (EXCLUDED_URLS.find(item => request.url.indexOf(item) > -1)) {
            return next.handle(request);
        } else {
                return this.sendRequest(request, next, auth);
        }

    }

    /**
     * To clone the http request and append the required headers
     * @param req htt request
     */
     /* addToken(request: HttpRequest<any>): HttpRequest<any> {
        let customReq: any;
        if(EXCLUDED_URLS.find(url => request.url.indexOf(url) > -1)){
            customReq = request.clone();
        }
        else {
            customReq = request.clone({
                headers: request.headers
                    .set('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN))
            });
        }
        return customReq;
    } */
/**
     * To clone the http request and append the required headers
     * @param req htt request
     */
    addToken(request: HttpRequest<any>): HttpRequest<any> {
        let customReq: any;
        let client_id: any;
        const client_secret = CommonConstants.CLIENT_ID_ENOTIFICATION_SEC_VAL;

        const basicheader = btoa(client_id + ':' + client_secret);
        if (request.url.indexOf('token?grant_type') > -1) {
            customReq = request.clone({
                headers: request.headers.set('Authorization', 'Basic ' + basicheader)
            });
        }  /* else if (request.url.indexOf('upload') > -1) {
            customReq = request.clone({
                headers: request.headers.set('Content-Type', "multipart/form-data;boundary=---------------------------275932272513031")
                    .set('Authorization', 'Bearer ' + localStorage.getItem(CommonConstants.ACCESS_TOKEN))
            });
        }  */ else {

            customReq = request.clone({
                headers: request.headers
                    .set('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN))
            /* ustomReq = request.clone({
                headers: request.headers.set('Content-Type', 'application/json')
                    .set('Authorization', 'Bearer ' + localStorage.getItem(CommonConstants.ACCESS_TOKEN)) */
            });
        }
        return customReq;
    }

    
    /**
     * To handle 400 error, for bad credentials throw exception.
     * @param error
     *
     */
    handle400Error(error, auth: any) {
        if (error && error.status === 400 && error.error) {
            if (error.error.apierror) {
                return auth.showErrorMessage(error.error['apierror'].message, 'apierror');
            } else {
                if (error.error.error === 'invalid_grant' && (error.error.error_description.indexOf("Bad") !== -1 || error.error.error_description.indexOf("User account has been") !== -1)) { // wrong user credentials
                    auth.showErrorMessage(error.error.error_description, 'login');
                    return throwError(error.error);
                } else if (error.error.error === 'invalid_grant' && error.error.error_description.indexOf("Invalid refresh token") !== -1) {// refresh token failed
                    auth.logoutUser(CommonConstants.REFRESH_TOKEN_FAILED);
                } else if (error.error.error === 'invalid_grant') {
                    auth.logoutUser(0);
                } else if (error.error.error === 'unauthorized') { //auth server failure
                    auth.logoutUser(0);
                }
            }


        }
        //return EmptyObservable.create(error);
        return Observable.throw(error);
    }

    /**
     * To handle 401 error, get refresh token and retry all active request with the new token
     */
    handle401Error(req: HttpRequest<any>, next: HttpHandler, auth: any, error) {
        //check invalid login Id error which returns 401.
        if (error.error.error === 'unauthorized' && error.error.error_description === 'BadCredentials') {
            return Observable.throw("");
        } else if (this.isRefreshingToken) {
            this.isRefreshingToken = false;

            // Reset here so that the following requests wait until the token
            // comes back from the refreshToken call.
            this.tokenSubject.next(null);

            return auth.refreshToken().switchMap((token) => {
                if (token) {
                    localStorage.setItem(CommonConstants.ACCESS_TOKEN, token["access_token"]);
                    localStorage.setItem(CommonConstants.REFRESH_TOKEN, token["refresh_token"]);
                    localStorage.setItem(CommonConstants.EXPIRES_IN, token["expires_in"]);
                    this.tokenSubject.next(token["access_token"]);
                    swal({
                        title: 'Validating Session..!',
                        text: 'Logging in....',
                        timer: 5000,
                        onOpen: function () {
                            swal.showLoading();

                        }
                    });
                    return next.handle(this.addToken(req));
                } else {
                    auth.logoutUser(0);
                }

                // If we don't get a new token, logout.

                //return EmptyObservable.create();
                return Observable.throw(error);

            }).catch((e: any) => {
                // If there is an exception calling 'refreshToken', logout.
                auth.logoutUser(0);
                //return EmptyObservable.create();
                return Observable.throw(error);
            }).finally(() => {
                this.isRefreshingToken = true;
            });

        } else {
            return this.tokenSubject.pipe(
                filter(token => token != null))
                .pipe(take(1))
                .pipe(switchMap(token => {
                    return next.handle(this.addToken(req));
                }))
        }
    }

    sendRequest(
        request: HttpRequest<any>,
        next: HttpHandler,
        auth: AuthService): Observable<any> {
        return next.handle(this.addToken(request))
            .pipe(
                map(event => {
                    if (event instanceof HttpResponse) {
                      //  cache.put(request, event);
                    }
                    this.status.setHttpStatus(true);
                    return event;
                }),
                catchError((error, ca) => {
                    if (error instanceof HttpErrorResponse) {
                        /**
                         * refresh token expired, then log out.
                         * error description is using to distinguish whether it is access token expired or refresh token expired
                         */
                        //pattern harcoded "Case Record" for save case failure to display custom message.
                       /*  if (error && error.status === 500 && error.error && error.error.apierror && error.error.apierror.debugMessage &&
                            (error.error.apierror.debugMessage.startsWith("Case record") || error.error.apierror.debugMessage.startsWith("Reporting date is greater"))) {
                            swal('Save Failed', error.error.apierror.debugMessage, 'error');
                            return Observable.throw(error);
                            (error);
                        } 
                        else if (error && error.status === 500 && error.error && error.error.apierror && error.error.apierror.debugMessage &&
                            (error.error.apierror.debugMessage.startsWith("Case is already linked") || error.error.apierror.debugMessage.startsWith("This patient is linked"))) {
                            swal(error.error.apierror.debugMessage,"", 'error');
                            //return ErrorObservable.create(error);
                            return Observable.throw(error);
                        }
                        else if (error && error.status === 500) {
                            if (request.url.indexOf('patients') > -1) {
                                swal('Could not retrieve patient details from Al Shifa', 'Please enter the Civil ID to proceed', 'warning');
                                //return ErrorObservable.create(error);
                                return Observable.throw(error);
                            } else if (request.url.indexOf('patientLabInvestigations') > -1) {
                                swal('Could not retrieve lab details from Al Shifa', '', 'warning');
                               // return ErrorObservable.create(error);
                                return Observable.throw(error);
                            } else if (request.url.indexOf('caseLabOrder') > -1) {
                                swal('Server error occured!', error.error.apierror.debugMessage, 'error');
                               // return ErrorObservable.create(error);
                               return Observable.throw(error);
                            }
                            swal('Server error occured!', 'Contact System Administrator', 'error');
                            //return ErrorObservable.create(error);
                            return Observable.throw(error);

                        } */

                        if (error && error.status === 401 && error.error && error.error.error === 'invalid_token'
                            && (error.error.error_description.indexOf("Invalid access token") !== -1 || error.error.error_description.indexOf("refresh") !== -1 || error.error.error_description.indexOf("expired") !== -1)) {
                            this.isRefreshingToken = true;
                            auth.logoutUser(CommonConstants.REFRESH_TOKEN_FAILED);
                        } else {
                            switch ((<HttpErrorResponse>error).status) {
                                case 401:
                                    this.status.setRequestResponse(true);
                                    return this.handle401Error(request, next, auth, error);
                                case 400:
                                    this.status.setRequestResponse(true);
                                    return this.handle400Error(error, auth);// invalid acess/refresh token
                                default:
                                    this.status.setHttpStatus(false);
                                    if (error.status === 0) {
                                        return auth.showErrorMessage(CommonConstants.HTTP_FAILED_STATUS_MSG, 'failed_request');
                                    } else {
                                        // this.sharedService.srvError.next(true);
                                        this.status.setRequestResponse(true);
                                        return auth.showErrorMessage(error.error['apierror'].debugMessage, 'apierror');
                                    }

                            }
                        }
                    } else {
                        return Observable.throw(error);
                       // return ErrorObservable.create(error);
                    }
                }),
                finalize(() => {
                    this.status.setHttpStatus(false);
                })
            )








        // return next.handle(this.addToken(request)).pipe(
        //   tap(event => {
        //     if (event instanceof HttpResponse) {
        //       cache.put(request, event);
        //     }
        //   })
        // );
    }

    setPrivileges() {
        const privileges = [];
        const roles = JSON.parse(localStorage.getItem(CommonConstants.USER_ROLES));
        for (let index = 0; index < roles.length; index++) {
            privileges.push(roles[index].privileges);
        }
        this.priviliges = privileges;
    }


    getPrivileges() {
        return this.priviliges;
    }

    hasPrivilege(privilege: String): boolean {
        let assignedPrivilege = [];
        if (!this.getPrivileges()[0]) {
            this.setPrivileges();
        }
        let index = -1;
        for (let i = 0; i < this.getPrivileges().length; i++) {
            index = this.getPrivileges()[i].findIndex((item) => {
                switch (item['name'] === privilege) {
                    case true:
                        assignedPrivilege.push(item);
                }
            })
        }

        if (assignedPrivilege.length > 0) {
            return true;
        } else {
            return false;
        }
    }
}
